import type { TranslationLocale } from './translations'

const DEFAULT_FALLBACK_LOCALE: TranslationLocale = 'hu'

export const localizeTranslationValue = (
    field: unknown,
    locale: TranslationLocale,
    fallbackLocale: TranslationLocale = DEFAULT_FALLBACK_LOCALE,
): string => {
    if (field === null || typeof field !== 'object' || Array.isArray(field)) {
        return ''
    }

    const entry = field as Record<string, unknown>

    const primary = entry[locale]
    if (typeof primary === 'string' && primary.length > 0) {
        return primary
    }

    const fallback = entry[fallbackLocale]
    if (typeof fallback === 'string' && fallback.length > 0) {
        return fallback
    }

    for (const key of Object.keys(entry)) {
        const value = entry[key]
        if (typeof value === 'string' && value.length > 0) {
            return value
        }
    }

    return ''
}
